
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ClassDetails } from "@/types/attendance";

export const useClassDetails = (classId: string | undefined) => {
  return useQuery<ClassDetails, Error>({
    queryKey: ['class-details', classId],
    queryFn: async () => {
      if (!classId) throw new Error("ID de clase no proporcionado");

      const { data, error } = await supabase
        .from('classes')
        .select('id, title, instructor, duration, schedule, capacity')
        .eq('id', classId)
        .single();

      if (error) throw error;
      return data as ClassDetails;
    },
    enabled: !!classId,
  });
};
